import { SocietyModel } from './society.model';

export class UserModel
{
	id: number = undefined;
	username: string = undefined;
	email: string = undefined;
	//password
	state: number = undefined;
	firstname: string = undefined;
	lastname: string = undefined;
	society_id: number = undefined;
	society: SocietyModel = undefined;
	phone: string = undefined;

	isAuditor: number = undefined;

	get name()
	{
		return this.firstname +' '+ this.lastname;
	}
	get initials()
	{
		return this.firstname.charAt(0)+' '+this.lastname.charAt(0);
	}


	constructor(values: Object) {
	   if(values) this.exchange(values);
	   else this.society = new SocietyModel(null);
	}
	exchange(values: Object = {}) {
		for (let p in values) {
	    	if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    				    		this[p] = values[p];
		    	} 
		    }
		    else if (p == '_embedded') {
	    		this.exchange(values[p]);
	    	}
		}

		if(this.society) this.society_id = this.society.id;
	}

	toString()
	{
		return this.name;
	}
}